import {SortOption} from '../../data/models/UI/SelectOption';

export const LIBRARY_ITEMS_PER_PAGE = 12;

export const LIBRARY_SORT_OPTIONS: SortOption[] = [
  {
    field: 'file_name',
    order: 'asc',
    title: 'Name (A-Z)',
  },
  {
    field: 'file_name',
    order: 'desc',
    title: 'Name (Z-A)',
  },
  {
    field: 'date_created',
    order: 'desc',
    title: 'Uploaded date (newest)',
  },
  {
    field: 'date_created',
    order: 'asc',
    title: 'Uploaded date (oldest)',
  },
  {
    field: 'size',
    order: 'asc',
    title: 'Size (smallest)',
  },
  {
    field: 'size',
    order: 'desc',
    title: 'Size (largest)',
  },
];

export const mapFileStatusToText = (status: number) => {
  switch (status) {
    case 1:
    case 2:
    case 3:
      return 'Initializing';
    case 4:
    case 5:
      return 'Reading files';
    case 6:
      return 'Integrating AI elements';
    case 7:
    case 8:
    case 9:
      return 'Adding voiceover';
    case 10:
    case 11:
      return 'Generating video';
  }
};
